<template>
    <div class="CoverageFormat">
      <img
        src="/images/sAoqVlf.jpg"
        alt="bigbanner-background"
        class="banner-img CoverageFormat__saturation"
      />
  
      <section class="mt-5">
        <nav class="container">
          <ul>
            <li><strong>POPULATION</strong> - The current population of Nigeria is <strong>215,203,368*</strong></li>
            <li><strong>NEIGHBOURING COUNTRIES*</strong> - Nigeria is bordered by Niger (north), Chad and Cameroon (east), Gulf of Guinea (south), and Benin (west).</li>
            <li><strong>LANGUAGE SPOKEN</strong> - English (official), plus Hausa, Yoruba, Igbo, Fula, and English Creole.</li>
            <li><strong>CURRENCY</strong> - Nigerian Naira (NGN).</li>
            <li><strong>INDUSTRIES</strong> - Petroleum, tourism, agriculture, mining, and services (telecom & finance).</li>
            <li>
              <strong>TOP 3 CITIES</strong>
              <ul>
                <li>Lagos</li>
                <li>Kano</li>
                <li>Ibadan</li>
              </ul>
            </li>
            <li><strong>WEATHER</strong> - Tropical: wet and dry seasons. Savanna in the north, steppe in the far north.</li>
            <li><strong>NATIONAL SPORT</strong> - Football. Nigeria is internationally competitive in FIFA and European leagues.</li>
          </ul>
  
          <div class="text-center">
            <img
              src="https://gistcdn.githack.com/juan-bits/4c843cf20657ffc830940f3e719c2b02/raw/19227509dd01ee8376f7d22f780db0e1f5ba2771/nigeria-flag.svg"
              alt="Nigeria flag"
              class="my-5 CoverageFormat__flag"
              style="width: 150px"
            />
          </div>
        </nav>
  
        <article>
          <p>
            Nigeria, officially known as the Federal Republic of Nigeria, is often called the "Giant of Africa" and is the seventh-most populous country in the world.
          </p>
  
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4034910.7009228664!2d6.4334882342906266!3d9.032489545414377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0baf7da48d0d%3A0x99a8fe4168c50bc8!2sNigeria!5e0!3m2!1sen!2ses!4v1652175620046!5m2!1sen!2ses"
            width="95%"
            height="450"
            class="CoverageFormat__margins"
            style="border: 0"
            loading="lazy"
            allowfullscreen
            title="Nigeria-map"
          ></iframe>
  
          <h4 class="mt-4">Tourism in Nigeria*</h4>
          <p>Nigeria's tourism thrives with cultural events, diverse ethnic groups, and natural attractions like rainforests and waterfalls.</p>
          <p>2019: $1.47B, 2018: $1.98B (↓25%), 2017: $2.62B (↑140% from 2016)</p>
  
          <h4 class="mt-4">Main Ports and Airports in Nigeria</h4>
          <p>32 airports (26 by FAAN), 5 international hubs.</p>
          <table class="table">
            <thead>
              <tr><th>IATA</th><th>Name</th><th>City</th></tr>
            </thead>
            <tbody>
              <tr><td>LOS</td><td>Murtala Muhammed Int'l Airport</td><td>Lagos</td></tr>
              <tr><td>ABV</td><td>Nnamdi Azikiwe Int'l Airport</td><td>Abuja</td></tr>
              <tr><td>PHC</td><td>Port Harcourt Int'l Airport</td><td>Port Harcourt</td></tr>
              <tr><td>KAN</td><td>Mallam Aminu Int'l Airport</td><td>Kano</td></tr>
            </tbody>
          </table>
          <p>Major seaports: Apapa, Tin Can, Onne, Warri, Calabar.</p>
          <ul>
            <li>LAGOS PORT COMPLEX</li>
            <li>TIN CAN ISLAND PORT</li>
            <li>CALABAR PORT</li>
            <li>RIVERS PORT</li>
            <li>DELTA PORT</li>
            <li>ONNE PORT</li>
          </ul>
  
          <h4 class="mt-5">Typical Nigerian Cuisine</h4>
          <p>Jollof rice – rice cooked with tomatoes, onions, and spices.</p>
  
          <h4 class="mt-5">Employment in Nigeria</h4>
          <p>Highest: 93.6% (Q4 2014), Lowest: 66.7% (Q4 2020)</p>
        </article>
      </section>
  
      <div class="container">
        <h4 class="my-5">Submarine Cables in Nigeria</h4>
        <a
          href="https://www.submarinecablemap.com/country/nigeria"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/images/gFJBGJc.png" alt="submarine cables" width="100%" />
        </a>
  
        <ol class="mt-4">
          <li>2Africa</li>
          <li>Nigeria Cameroon Submarine Cable</li>
          <li>Equiano</li>
          <li>WACS</li>
          <li>MainOne</li>
          <li>Africa Coast to Europe</li>
          <li>Glo-1</li>
          <li>SAT-3/WESC</li>
        </ol>
  
        <h4 class="my-4">Mobile and Landline Internet Access in Nigeria*</h4>
        <p>101.7M mobile internet users (2021); 5G and broadband driving future growth.</p>
  
        <h4 class="my-4">Wireless Network Expansion</h4>
        <p>5G adoption supports IoT and advanced mobile services.</p>
  
        <h4 class="my-4">Our Internet Services in Nigeria</h4>
        <p>
          Partnering with 8 infrastructure-owning providers for DIA, Business Broadband, 4G/5G LTE.
        </p>
        <p>Services available in Benin, Agbara, and Lagos with 24/7 NSOC support.</p>
  
        <table class="table table-striped mb-5">
          <tbody>
            <tr><td>Dedicated Lines</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Business Broadband</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Wireless Connectivity</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>CPE / Router</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>GEMS</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Diverse Gateway Solutions</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>DDoS</td><td><i class="fas fa-check"></i></td></tr>
          </tbody>
        </table>
  
        <p class="CoverageFormat__tag CoverageFormat__margins text-center" align="justify">
          With our Global Business Solutions team, we provide a <mark>Commercial Offer in 2–3 working days</mark>. Services delivered in Lagos & Benin: 3–4 weeks; other cities: 5–6 weeks.
        </p>
  
        <p class="text-center">
          For more info, <a href="mailto:sales@inte-QT.com?subject=Mail from Our Site">Email Us</a>.
        </p>
  
        <h4>* - References</h4>
        <ul>
          <li><a href="https://www.worldometers.info/world-population/nigeria-population/" target="_blank">Reference 1</a></li>
          <li><a href="https://www.britannica.com/place/Nigeria" target="_blank">Reference 2</a></li>
          <li><a href="https://www.globalmonitor.us/product/nigeria-telecommunication-market-report" target="_blank">Reference 3</a></li>
        </ul>
      </div>
  
      <GetInTouch />
    </div>
  </template>
  
  <script setup>
  import { useHead } from '@vueuse/head'
  import GetInTouch from '@/components/GetInTouch.vue'
  
  useHead({
    title: 'Internet Connectivity and Telecommunication in Nigeria - inte-QT',
    meta: [
      {
        name: 'title',
        content: 'Internet Connectivity and Telecommunication in Nigeria - inte-QT',
      },
      {
        name: 'description',
        content:
          'Explore the internet and telecommunication landscape in Nigeria with inte-QT services, including 4G, 5G, and broadband solutions.',
      },
      {
        name: 'keywords',
        content:
          'internet in Nigeria, telecommunications in Nigeria, broadband solutions Nigeria, 5G services Nigeria, mobile internet Nigeria, Nigeria infrastructure, telecom market growth, Nigeria submarine cables, Nigeria internet providers',
      },
    ],
    link: [{ rel: 'canonical', href: 'https://www.inte-qt.com/coverage/nigeria' }],
  })
  </script>
  
  <style scoped>
.CoverageFormat {
  color: black;
}

.CoverageFormat__title {
  position: absolute;
  width: 50vw;
  top: 15vh;
  left: 25vw;
  line-height: 1.5;
  font-size: 3rem;
  font-weight: 500; 
  color: #ffffff;  
}

@media (max-width: 992px) {
  .CoverageFormat__title {
    font-size: 3rem;
    width: 40vw;
    top: 30vh;
    left: 55vw;
  }
}

@media (max-width: 768px) {
  .CoverageFormat__title {
    font-size: 2rem;
    width: 40vw;
    top: 25vh;
    left: 55vw;
  }
}

@media (max-width: 576px) {
  .CoverageFormat__title {
    top: 12vh;
    left: 5vw;
    width: 90vw;
    font-size: 1.5rem;
  }
}

.CoverageFormat__tag {
  font-size: 1.5rem;
}

.CoverageFormat section {
  display: -webkit-flex;
  display: flex;
}

.CoverageFormat nav {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.CoverageFormat nav ul {
  padding: 0;
}

.CoverageFormat ul li,
.CoverageFormat ol li {
  margin: 1rem;
  text-align: left;
}

.CoverageFormat article {
  color: black;
  -webkit-flex: 3;
  -ms-flex: 3;
  flex: 3;
  padding: 10px;
}

.CoverageFormat__saturation {
  filter: drop-shadow(1px 10px 40px rgb(0, 0, 0)) saturate(110%);
}

.CoverageFormat__margins {
  margin: 3rem;
}

@media (max-width: 768px) {
  .CoverageFormat__margins {
    margin: 1rem 0 1rem 0;
    text-align: left;
  }
}

.CoverageFormat__flag {
  width: 150px;
  border: 1px solid black;
}

@media (max-width: 768px) {
  .CoverageFormat section {
    -webkit-flex-direction: column;
    flex-direction: column;
  }
}
  </style>
  